import React from 'react'
import { useTheme } from 'styled-components'

import { IconComponent } from '@application/Interfaces/Icons/types'
import { Theme } from '@application/Interfaces/Themes/ThemeType'

export const InternationalRelocationsIcon: IconComponent = ({
    className,
    colorCode = 'p500',
    width = 43,
    height = 43,
}) => {
    const theme = useTheme() as Theme
    const color = theme.color[colorCode]

    return (
        <svg
            className={className}
            width={width}
            height={height}
            viewBox="0 0 192 192"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <defs>
                <style>{`.cls-3,.cls-4{fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:7.00px;}.cls-3{stroke:${color};}.cls-4{stroke:#FF4D00;}`}</style>
            </defs>
            <line className="cls-3" x1="28.17" y1="167.15" x2="163.83" y2="167.15"></line>
            <line className="cls-3" x1="152.37" y1="97.02" x2="152.37" y2="167.12"></line>
            <line className="cls-3" x1="39.63" y1="167.05" x2="39.63" y2="97.02"></line>
            <path className="cls-3" d="M76,167.05V115a10,10,0,0,1,10-10h20a10,10,0,0,1,10,10v52"></path>
            <path className="cls-4" d="M43.74,65.5V22.6a10,10,0,0,1,10-10H57.5a10,10,0,0,1,10,10V44"></path>
            <path className="cls-3" d="M29.49,78.7l60-51.43a10,10,0,0,1,13,0l60,51.43"></path>
        </svg>
    )
}
